import * as React from 'react';
import './index.scss';
import { useAppSelector } from './../../../../toolkit';
import classNames from 'classnames';
import { HYDevice, HYRouter, HYShare, HYToast } from '@hy-hybrid/kiwi-js-sdk';
import { generateHuyaShareWord, reportFuc, canOpen } from './../../../../utils';
import Serve from '../../../../serve';
const { copyToClipboard } = HYDevice;
const { openUrl } = HYRouter;
const { shareTo } = HYShare;
const { showToast } = HYToast;
const { useEffect } = React;
interface PropsInterface {
  iOld?: boolean;
  status: number;
  set: any;
  showWechat: any;
  // awardConfig: any
  qrCodeData: string;
  inviteCode: {
    4: string;
    1: string;
    2: string;
    3: string;
  };
}
let firstLoad = true;
const Share: React.FC<PropsInterface> = (props) => {
  const { uid } = useAppSelector((state) => state.base);
  const { iOld, qrCodeData } = props;
  useEffect(() => {
    if (!!props.status) {
      reportFuc(
        'sys/pageview/ldx/share',
        '系统/页面展示/老带新/分享方式选择浮层曝光',
        {}
      );
    }
  }, [props.status]);
  return (
    <>
      {!!props.status && (
        <div
          className="shadow"
          onClick={() => {
            firstLoad = false;
            props.set(false);
          }}
        />
      )}
      <ul
        className={classNames('share-whole', {
          long: !iOld,
          longOut: !iOld && !firstLoad && !props.status,
          longIn: !iOld && props.status,
          in: iOld && props.status,
          out: iOld && !firstLoad && !props.status
        })}
      >
        {!iOld && <div className="banner" />}
        <ul className={classNames('share')}>
          {[
            ['qrcode', '面对面扫码'],
            ['qq', 'QQ'],
            ['weixin', '微信'],
            ['copy', '复制链接']
          ].map((item, idx) => (
            <li
              key={idx}
              onClick={async () => {
                reportFuc(
                  'usr/click/ldx/share/activitysharemode',
                  '用户/点击/老带新/分享方式选择浮层/活动分享方式点击',
                  { activity_share_mode: idx + 1 }
                );
                // const url = (
                //   location.protocol +
                //   '//' +
                //   location.host +
                //   location.pathname
                // ).replace(/\/index.html/, `/share1.html?client=1&uid=${uid}`);
                const shorturl = await Serve.getShortUrl({
                  sUrl:
                    location.protocol +
                    '//' +
                    location.host +
                    location.pathname.replace(/\/index.html/, '/'),
                  iLevel: 1,
                  sUrlSuffix: 'share1.html'
                });
                const { data } = shorturl;
                console.log(
                  'shorturl: ',
                  data.sShotUrl + `?client=1&uid=${uid}`
                );
                let url = 'https://' + data.sShotUrl + `?client=1&uid=${uid}`;
                if (/test-hd/g.test(location.host)) {
                  url = (
                    location.protocol +
                    '//' +
                    location.host +
                    location.pathname
                  ).replace(/\/index.html/, `/share1.html?client=1&uid=${uid}`);
                }
                let code: any = null;
                switch (item[0]) {
                  case 'copy':
                    if (!props.inviteCode['3']) return;
                    code = props.inviteCode['3'].match(/#(\S*)#/);
                    if (!code)
                      return showToast({
                        message: '无邀请码!'
                      });
                    copyToClipboard({ text: url + `&iType=3&code=${code[1]}` });
                    firstLoad = false;
                    props.set(false);
                    break;
                  case 'qrcode':
                    if (!props.inviteCode['4']) return;
                    code = props.inviteCode['4'].match(/#(\S*)#/);
                    if (!code)
                      return showToast({
                        message: '无邀请码!'
                      });
                    const qrcodeUrl = (
                      location.protocol +
                      '//' +
                      location.host +
                      location.pathname
                    ).replace(
                      /\/index.html/,
                      `/qrcode.html?hideShareButton=1&code=${
                        code[1]
                      }&iOld=${iOld}&qrCodeData=${JSON.stringify(qrCodeData)}`
                    );
                    openUrl({ url: qrcodeUrl });
                    firstLoad = false;
                    props.set(false);
                    break;
                  case 'weixin':
                    // if (!props.inviteCode['2']) return;
                    // props.set(false);
                    // copyToClipboard({
                    //   text: generateHuyaShareWord(
                    //     props.inviteCode['2'],
                    //     props.status === 1
                    //       ? '复制整段话，打开虎牙直播App，必得现金8.8元'
                    //       : '复制整段话，打开虎牙直播App，天天领现金'
                    //   ),
                    // });
                    // props.showWechat();
                    const message2 = '请安装微信后再使用此功能哦!';
                    canOpen('weixin').then((rsp) => {
                      if (rsp) {
                        if (!props.inviteCode['2']) return;
                        code = props.inviteCode['2'].match(/#(\S*)#/);
                        if (!code)
                          return showToast({
                            message: '无邀请码!'
                          });
                        const shareUrl = url + `&iType=0&code=${code[1]}`;
                        shareTo({
                          platform: 'weixin',
                          imageUrl:
                            'https://diy-assets.msstatic.com/202104invite/weixinshare.png',
                          title: '来虎牙看直播，最高可得8.8元现金！',
                          content:
                            '登录后接受邀请，看任意直播即可得奖励！新人必得8.8',
                          shareUrl
                        });
                        firstLoad = false;
                        props.set(false);
                      } else {
                        showToast({
                          message: message2
                        });
                      }
                    });
                    break;
                  case 'qq':
                    const message = '请安装QQ后再使用此功能哦!';
                    canOpen('qq').then((rsp) => {
                      if (rsp) {
                        if (!props.inviteCode['1']) return;
                        code = props.inviteCode['1'].match(/#(\S*)#/);
                        if (!code)
                          return showToast({
                            message: '无邀请码!'
                          });
                        const shareUrl = url + `&iType=1&code=${code[1]}`;
                        shareTo({
                          platform: 'qq',
                          title:
                            props.status === 1
                              ? '快来和我一起领现金'
                              : '快来上线领现金',
                          content:
                            props.status === 1
                              ? '下载虎牙直播App，新人必得8.8元'
                              : '访问虎牙直播App，新人必得8.8元',
                          shareUrl,
                          imageUrl:
                            'https://diy-assets.msstatic.com/202104invite/open.png'
                        });
                        firstLoad = false;
                        props.set(false);
                      } else {
                        showToast({
                          message
                        });
                      }
                    });
                    break;
                  default:
                    return;
                }
              }}
            >
              <i className={item[0]} />
              <p>{item[1]}</p>
            </li>
          ))}
        </ul>
        <div
          className="cancel"
          onClick={() => {
            firstLoad = false;
            props.set(false);
          }}
        >
          取消
        </div>
      </ul>
    </>
  );
};

export default Share;
